const TagListClass = function (elem) {
  let nodelist = elem.querySelectorAll("li");
  for (let i = 0; i < nodelist.length; i++) {
    nodelist[i].onclick = function (e) {
      let currentTag = e.currentTarget
        .querySelector("a")
        .innerHTML.trim()
        .replace("%", "");

      removeActiveState();
      e.currentTarget.classList.add("active");
      e.preventDefault();
      let gridItems = document.querySelectorAll(
        "#main-collection-grid .collection--grid-item"
      );
      if ("All Flavors" == currentTag) {
        for (let i = 0; i < gridItems.length; i++) {
          gridItems[i].classList.remove("d-none");
        }
        return false;
      }

      for (let i = 0; i < gridItems.length; i++) {
        let value = gridItems[i].getAttribute("data-tags");
        if ("" != value) {
          let tags = value.split(",");
          for (let k = 0; k < tags.length; k++) {
            if (tags[k] == currentTag) {
              gridItems[i].classList.remove("d-none");
              break;
            } else {
              gridItems[i].classList.add("d-none");
            }
          }
        } else {
          gridItems[i].classList.add("d-none");
        }
      }
    };
  }

  function removeActiveState() {
    let nodelist = elem.querySelectorAll("li");
    for (let i = 0; i < nodelist.length; i++) {
      nodelist[i].classList.remove("active");
    }
  }
};

let nodelist = document.querySelectorAll(".TagList");
for (let i = 0; i < nodelist.length; i++) {
  let tagList = new TagListClass(nodelist[i]);
}

const QuickbuyModal = function () {
  function closeAllModals() {
    let nodelist = document.querySelectorAll(".quickbuy-modal");
    for (let i = 0; i < nodelist.length; i++) {
      nodelist[i].classList.remove("modal-is-opened");
    }
  }

  let currentHash = window.location.hash.replace("#", "");
  let nodelist = document.querySelectorAll(".quickbuy-modal");
  for (let i = 0; i < nodelist.length; i++) {
    document.body.append(nodelist[i]);
    if (
      currentHash &&
      currentHash == nodelist[i].getAttribute("data-quickbuy-modal-id")
    ) {
      nodelist[i].classList.add("modal-is-opened");
      document.body.classList.add("is-in-modal");
    }
    [...nodelist[i].querySelectorAll(".quickbuy-modal--close_wrapper")].forEach(
      (closer) => {
        closer.addEventListener("click", () => {
          closeAllModals();
          document.body.classList.remove("is-in-modal");
        });
      }
    );
  }
};

document.addEventListener("DOMContentLoaded", () => {
  QuickbuyModal();
});
